import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { APPROVAL_STATUS_NOT_STARTED, APPROVAL_STATUS_NOT_NEEDED } from '../constants';
import AsyncPipelineApprovalsCardPopover from './AsyncPipelineApprovalsCardPopover';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getApprovalTitleMessageKey = status => {
  return `customer-data-board-card.approval.title.${status}`;
};

/**
 * Copied from https://git.hubteam.com/HubSpot/foundations-components/blob/master/foundations-components/static-1.5838/js/transitional/components/Tag/Tag.tsx#L72-L85
 */
export const TAG_BORDER_COLORS = {
  'candy-apple': 'fill-accent-red-default',
  pantera: 'fill-accent-neutral-default',
  calypso: 'fill-accent-blue-default',
  koala: 'fill-tertiary-default',
  lorax: 'fill-accent-orange-default',
  marigold: 'fill-accent-yellow-default',
  norman: 'fill-accent-magenta-default',
  olaf: 'icon-core-subtle',
  oz: 'fill-accent-green-default',
  sorbet: 'fill-accent-light-orange-default',
  thunderdome: 'fill-accent-purple-default',
  default: 'border-core-hover'
};
const StatusColorMap = {
  pending: {
    color: TAG_BORDER_COLORS['marigold'],
    use: 'marigold'
  },
  not_started: {
    color: TAG_BORDER_COLORS['default'],
    use: 'default'
  },
  cancelled: {
    color: TAG_BORDER_COLORS['default'],
    use: 'default'
  },
  approved: {
    color: TAG_BORDER_COLORS['oz'],
    use: 'oz'
  },
  rejected: {
    color: TAG_BORDER_COLORS['candy-apple'],
    use: 'candy-apple'
  },
  no_approval_needed: {
    color: TAG_BORDER_COLORS['oz'],
    use: 'oz'
  }
};
const Wrapper = styled.div.withConfig({
  displayName: "ApprovalStatus__Wrapper",
  componentId: "sc-1tqupy1-0"
})(({
  theme
}) => `
  font-size: ${theme.typography['detail-100'].fontSize};
`);
const Border = styled.div.withConfig({
  displayName: "ApprovalStatus__Border",
  componentId: "sc-1tqupy1-1"
})(({
  theme,
  status
}) => `
  background-color: ${theme.color[StatusColorMap[status]['color']]};
  border-radius: 2px 0 0 2px;
  width: 4px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  margin-left: ${theme.space['0']};
`);
const getLatestApprovalStatus = subject => subject.properties.hs_latest_approval_status ? subject.properties.hs_latest_approval_status.value : undefined;
export const ApprovalStatus = ({
  subject,
  objectTypeId,
  onTrack
}) => {
  const status = getLatestApprovalStatus(subject) || APPROVAL_STATUS_NOT_STARTED;
  const objectId = subject && subject.objectId;
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(Border, {
      status: status
    }), /*#__PURE__*/_jsxs(TFlex, {
      paddingBlockEnd: "100",
      wrap: "nowrap",
      children: [/*#__PURE__*/_jsxs(TFlex, {
        gap: 5,
        inlineSize: "auto",
        children: [/*#__PURE__*/_jsx(StatusDot, {
          color: StatusColorMap[status].color,
          use: StatusColorMap[status].use,
          marginBlockStart: "100"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: getApprovalTitleMessageKey(status)
        })]
      }), status !== APPROVAL_STATUS_NOT_NEEDED && /*#__PURE__*/_jsx(AsyncPipelineApprovalsCardPopover, {
        objectId: String(objectId),
        objectTypeId: objectTypeId,
        onTrack: onTrack
      })]
    })]
  });
};